import * as React from 'react';
import {Breadcrumb, Grid} from 'semantic-ui-react';
import i18n from '../../../../../locale/i18n';
import {NavLink, RouteComponentProps, withRouter} from 'react-router-dom';
import {
    ColumnSelectableComponentProps,
    ColumnSortableComponentProps,
    FilterObjectComponentProps,
    InfinityScrollComponentProps,
    ViewSettingsComponentProps,
    withColumnSelection,
    withColumnSort,
    withFilterObject,
    withInfinityScrollHandlers,
    withPrintAndExport,
    withViewSettings
} from '../../../components/DataTable/dataService';
import {DataTable} from '../../../components/DataTable/DataTable';
import LoadingSpinner from '../../../containers/LoadingContainer/LoadingSpinner';
import {ColumnDefinition} from '../../../components/DataTable/common';
import ContentContainer from '../../../containers/ContentContainer/ContentContainer';
import {ColumnSelectionButton} from '../../../components/DataTable/ColumnSelection';
import LoadingContainer from '../../../containers/LoadingContainer/LoadingContainer';
import {AnalyticsTracking} from "../../../components/AnalyticsTracking/AnalyticsTracking";
import LogisticsAvalancheServiceSingleton from "../../../services/LogisticAvalancheService";
import Moment from "react-moment";
import moment from "moment";
import _get from "lodash/get";
import ExportContextHolder from "../../../../../lib/ExportContextHolder";

const t = i18n.t.bind(i18n);

const getScrollParent = () => ContentContainer.instance.componentRef.current;

let COLUMNS: ColumnDefinition[] = [
    {fieldName: 'data.status', labelTranslationKey: 'Inventory.State'},
    {fieldName: 'data.dateTransaction', labelTranslationKey: 'Inventory.Date'},
    {fieldName: 'data.dateProcessed', labelTranslationKey: 'Inventory.DateProcessed'},
    {fieldName: 'data.transactionNumber', labelTranslationKey: 'Inventory.TransactionNumber'},
    {fieldName: 'data.contractorNumber', labelTranslationKey: 'Inventory.ContractorNumber'},
    {fieldName: 'data.contractorName', labelTranslationKey: 'Inventory.ContractorName'},
    {fieldName: 'data.transactionType', labelTranslationKey: 'Inventory.TransactionType'},
    {fieldName: 'data.transactionFlowTypeName', labelTranslationKey: 'Inventory.TransactionFlowTypeName'},
    {fieldName: 'data.depotNumber', labelTranslationKey: 'Inventory.DepotNumber'},
    {fieldName: 'data.depotName', labelTranslationKey: 'Inventory.DepotName',},
    {fieldName: 'data.depotNumberCounterpart', labelTranslationKey: 'Inventory.DepotNumberCounterpart'},
    {fieldName: 'data.depotNameCounterpart', labelTranslationKey: 'Inventory.DepotNameCounterpart'},
    {fieldName: 'data.documentNumber', labelTranslationKey: 'Inventory.DocumentNumber'},
    {fieldName: 'data.transportRefNumber', labelTranslationKey: 'Inventory.TransportRefNumber'},

    {fieldName: 'data.licensePlate', labelTranslationKey: 'Inventory.LicensePlate'},
    /*{fieldName: 'data.notesExternal', labelTranslationKey: 'Inventory.NotesExternal'},
    {fieldName: 'data.flowDirection', labelTranslationKey: 'Inventory.FlowDirection'},
    */
    {fieldName: 'data.bestand1', label: "", required: true},
    {fieldName: 'data.bestand2', label: "", required: true},
    {fieldName: 'data.bestand3', label: "", required: true},
    {fieldName: 'data.bestand4', label: "", required: true},
    {fieldName: 'data.bestand5', label: "", required: true},
];

const DEFAULT_COLUMNS = [
    "data.dateTransaction",
    "data.transactionNumber",
    "data.contractorNumber",
    "data.transactionFlowTypeName",

    "data.depotNameCounterpart",

    "data.documentNumber",

    "data.bestand1",
    "data.bestand2",
    "data.bestand3",
    "data.bestand4",
    "data.bestand5"
];

const InventoryAvalancheMovements = (props: RouteComponentProps<{accountNumber: string; ltNumber: string; market: string; }> & InfinityScrollComponentProps & FilterObjectComponentProps & ColumnSelectableComponentProps & ColumnSortableComponentProps  & ViewSettingsComponentProps) => {

    const getAccountName = () => {
        if(props.data != null) {

            if (_get(props.data, '0.data.depotNumber', '') === props.match.params.accountNumber)
                return _get(props.data, '0.data.depotName', '');

            if (_get(props.data, '0.data.depotNumberCounterpart', '') === props.match.params.accountNumber)
                return _get(props.data, '0.data.depotNameCounterpart', '');

            return "";
        }
        return '';
    };

    const getLtName = () => {
        if(props.data != null) {
            return _get(props.data, '0.data.itemSetName', '');
        }
        return '';
    };

    const getMarketName = () => {
        if(props.data != null) {
            return _get(props.data, '0.data.contractorName', '');
        }
        return '';
    };

    const getStockCaption = (id: number) => {
        if(props.data != null) {
            return _get(props.data, '0.data.itemNameShort' + id, '---');
        }
        return '---';
    }

    COLUMNS = [
        {fieldName: 'data.status', labelTranslationKey: 'Inventory.State'},
        {fieldName: 'data.dateTransaction', labelTranslationKey: 'Inventory.Date', required: true,
            cellRender: (v,r) => (v!== "") && (props.match.params.accountNumber === _get(r, "data.depotNumberCounterpart")) ? <Moment format={t("Common.DateTimeFormat")}>{_get(r, "data.dateTransactionCounterpart")}</Moment> :  <Moment format={t("Common.DateTimeFormat")}>{v}</Moment>,
            printExportRender: (v,r) => moment(v).format(t("Common.DateFormat"))},
        {fieldName: 'data.dateProcessed', labelTranslationKey: 'Inventory.DateProcessed',
            cellRender: (v,r) => (v!== "") && <Moment format={t("Common.DateTimeFormat")}>{v}</Moment>,
            printExportRender: (v,r) => moment(v).format(t("Common.DateTimeFormat"))},
        {fieldName: 'data.transactionNumber', labelTranslationKey: 'Inventory.TransactionNumber'},
        {fieldName: 'data.contractorNumber', labelTranslationKey: 'Inventory.ContractorNumber'},
        {fieldName: 'data.contractorName', labelTranslationKey: 'Inventory.ContractorName'},
        {fieldName: 'data.transactionType', labelTranslationKey: 'Inventory.TransactionType'},
        {fieldName: 'data.transactionFlowTypeName', labelTranslationKey: 'Inventory.TransactionFlowTypeName'},
        {fieldName: 'data.depotNumber', labelTranslationKey: 'Inventory.DepotNumber', cellRender: (v,r) => props.match.params.accountNumber === _get(r, "data.depotNumberCounterpart") ? _get(r, "data.depotNumberCounterpart") : v},
        {fieldName: 'data.depotName', labelTranslationKey: 'Inventory.DepotName', cellRender: (v,r) => props.match.params.accountNumber === _get(r, "data.depotNumberCounterpart") ? _get(r, "data.depotNameCounterpart") : v},
        {fieldName: 'data.depotNumberCounterpart', labelTranslationKey: 'Inventory.DepotNumberCounterpart',
            cellRender: (v,r) => props.match.params.accountNumber === _get(r, "data.depotNumberCounterpart") ? _get(r, "data.depotNumber") : v,
            printExportRender: (v,r) => props.match.params.accountNumber === _get(r, "data.depotNumberCounterpart") ? _get(r, "data.depotName") : v},
        {fieldName: 'data.depotNameCounterpart', labelTranslationKey: 'Inventory.DepotNameCounterpart',
            cellRender: (v,r) => props.match.params.accountNumber === _get(r, "data.depotNumberCounterpart") ? _get(r, "data.depotName") : v,
            printExportRender: (v,r) => props.match.params.accountNumber === _get(r, "data.depotNumberCounterpart") ? _get(r, "data.depotName") : v},
        {fieldName: 'data.documentNumber', labelTranslationKey: 'Inventory.DocumentNumber'},
        {fieldName: 'data.transportRefNumber', labelTranslationKey: 'Inventory.TransportRefNumber'},
        {fieldName: 'data.licensePlate', labelTranslationKey: 'Inventory.LicensePlate'},
        /*{fieldName: 'data.notesExternal', labelTranslationKey: 'Inventory.NotesExternal'},
        {fieldName: 'data.flowDirection', labelTranslationKey: 'Inventory.FlowDirection',
            cellRender: (v,r) => (props.match.params.accountNumber === _get(r, "data.depotNumberCounterpart") && v==="out" ? "in" : "out" )|| v,
            printExportRender: (v,r) => (props.match.params.accountNumber === _get(r, "data.depotNumberCounterpart") && v==="out" ? "in" : "out" )|| v},
        */
        {fieldName: 'data.bestand1', label: getStockCaption(1),
            cellRender: (v,r) => props.match.params.accountNumber === _get(r, "data.depotNumberCounterpart") ? v && (v * -1) : v,
            printExportRender: (v,r) => props.match.params.accountNumber === _get(r, "data.depotNumberCounterpart") ? v && (v * -1) : v },
        {fieldName: 'data.bestand2', label: getStockCaption(2),
            cellRender: (v,r) => props.match.params.accountNumber === _get(r, "data.depotNumberCounterpart") ? v && (v * -1) : v,
            printExportRender: (v,r) => props.match.params.accountNumber === _get(r, "data.depotNumberCounterpart") ? v && (v * -1) : v },
        {fieldName: 'data.bestand3', label: getStockCaption(3),
            cellRender: (v,r) => props.match.params.accountNumber === _get(r, "data.depotNumberCounterpart") ? v && (v * -1) : v,
            printExportRender: (v,r) => props.match.params.accountNumber === _get(r, "data.depotNumberCounterpart") ? v && (v * -1) : v },
        {fieldName: 'data.bestand4', label: getStockCaption(4),
            cellRender: (v,r) => props.match.params.accountNumber === _get(r, "data.depotNumberCounterpart") ? v && (v * -1) : v,
            printExportRender: (v,r) => props.match.params.accountNumber === _get(r, "data.depotNumberCounterpart") ? v && (v * -1) : v },
        {fieldName: 'data.bestand5', label: getStockCaption(5),
            cellRender: (v,r) => props.match.params.accountNumber === _get(r, "data.depotNumberCounterpart") ? v && (v * -1) : v,
            printExportRender: (v,r) => props.match.params.accountNumber === _get(r, "data.depotNumberCounterpart") ? v && (v * -1) : v },
    ];

    ExportContextHolder.fields = COLUMNS.map(c => c.labelTranslationKey? t(c.labelTranslationKey) : c.label);
    ExportContextHolder.columns = COLUMNS;
    ExportContextHolder.reloadHeaderFunc();

    if(props.loadingInitial) {
        return <LoadingContainer showLogo={false}/>;
    }
    return (
        <>
            <AnalyticsTracking page="logistics-avalanche-movements" />

            <div className={"sticky-header"}>
                <div className={"ui container"}>
                    <h3><Breadcrumb icon="right angle" sections={[
                        {key: '1',
                            as: NavLink,
                            to: '/logistics/inventory-avalanche',
                            content: `${t("Route.InventoryAvalanche")}`, link: true},
                        {key: '2',
                            content: `${t("Inventory.Account")}: ${props.match.params.accountNumber} ${getAccountName()}`,
                            active: true
                        },{key: '3',
                            content: `${t("Inventory.LTNumber")}: ${props.match.params.ltNumber} ${getLtName()}`,
                            active: true
                        },{key: '4',
                            content: `${t("Inventory.Market")}: ${props.match.params.market} ${getMarketName()}`,
                            active: true
                        }
                    ]}/></h3>

                    <p>{t("Common.Found$dDatasets", {count: props.totalItems})}</p> <br/>
                    <Grid columns={4} className={"HeadingGrid"} stackable={true}>
                        <Grid.Column width={11}>
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <ColumnSelectionButton
                                fluid
                                availableColumns={COLUMNS}
                                selectedColumns={props.selectedColumns}
                                onSave={props.updateSelectedColumns}/>
                        </Grid.Column>
                        <Grid.Column width={1}>
                            <div style={{opacity: (props.loading) ? '1.0' : '0.0', width:"100%"}}>
                                <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
                                </div>
                            </div>
                        </Grid.Column>
                    </Grid>
                </div>
            </div>
            <div className={"ui container responsivewrapper"}>
                <DataTable
                    columns={COLUMNS}
                    data={props.data}
                    page={props.page}
                    totalPages={props.totalPages}
                    sortDirection={props.sortDirection}
                    sortColumn={props.sortColumn}
                    selectedColumns={props.selectedColumns}
                    getScrollParent={getScrollParent}
                    loadMore={props.loadMore}
                    handleSortChange={props.handleSortChange}
                    loading={props.loading}
                />
                <div style={{opacity: props.loadingMore ? '1.0' : '0.0'}}>
                    <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
                    </div>
                </div>
                <div style={{height: '2em'}}/>
            </div>
        </>
    )
};

const InventoryAvalancheMovementsWrapped = withRouter(withViewSettings(withFilterObject(withColumnSort(withColumnSelection(withPrintAndExport(withInfinityScrollHandlers(InventoryAvalancheMovements)))))));

export default (props: RouteComponentProps<{accountNumber: string; ltNumber: string; market: string;}>) => {
    const dataService = {
        loadPage(page: number, sortColumn: string, sortOrder: 'ASC' | 'DESC', filter: { [p: string]: any }): Promise<any> {
            return LogisticsAvalancheServiceSingleton.getMovementsForAccountAndLTAndMarket(props.match.params.accountNumber, props.match.params.ltNumber, props.match.params.market, sortColumn, sortOrder, page, 50)
        }
    };

    return <InventoryAvalancheMovementsWrapped
        viewName="movements-avalanche"
        dataService={dataService}
        defaultSortDirection="DESC"
        defaultSortColumn="data.dateTransaction"
        defaultColumns={DEFAULT_COLUMNS}
        printColumns={COLUMNS}
        defaultFilter={{}}
        printPath={[`${t ("Route.InventoryAvalanche")}`]}
    />

}